/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useAuth } from "../../../../app/modules/auth";
import { toAbsoluteUrl } from "../../../helpers";

const HeaderUserMenu: FC = () => {
  const { currentUser, logout, setSelectedApplication, setSelectedDealer, setSelectedLanguage } = useAuth();

  const resetLanguageId = async () => {
    await setSelectedLanguage("", true);
  };

  const resetApplicationId = async () => {
    await setSelectedApplication("", true);
  };

  const resetDealerId = async () => {
    await setSelectedDealer("", true);
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img alt="Logo" src={toAbsoluteUrl("/media/avatars/300-2.jpg")} />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bold d-flex align-items-center fs-5">
              {currentUser?.user_name}
            </div>
            <a href="#" className="fw-semibold text-muted text-hover-primary fs-7">
              {currentUser?.dealer_name}
            </a>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            resetDealerId();
          }}
          className="menu-link px-5"
        >
          <span className="menu-text">Change Dealer</span>
        </a>
      </div>

      <div className="menu-item px-5">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            resetApplicationId();
          }}
          className="menu-link px-5"
        >
          <span className="menu-text">Change Application</span>
        </a>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            resetLanguageId();
          }}
          className="menu-link px-5"
        >
          <span className="menu-text">Change Language</span>
        </a>
      </div>

      <div className="separator my-2"></div>

      {/*<Languages/>*/}

      <div className="menu-item px-5">
        <a onClick={logout} className="menu-link px-5">
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
